enum ScheduleScriptOptionTypeEnum {
	INITIAL = 'initial',
	FLOW = 'flow',
	RETRY = 'retry',
	TELEMEDICINE = 'telemedicine',
	SCHEDULE = 'schedule',
	CHAT = 'chat',
	CLOSE = 'close',
	CLIENT_RESPONSE = 'client-response',
}

type AdditionalData = {
	slug: string;
	description: string;
	data: number;
};

type ScheduleScriptOption = {
	id: number;
	option: string;
	type: ScheduleScriptOptionTypeEnum;
	additionalData: Partial<AdditionalData>;
};

type QuestionsScheduleScript = {
	questionId: number;
	question: string;
	additionalText: string;
	options: ScheduleScriptOption[];
};

type GetQuestionsScheduleScriptModel = {
	pergunta: QuestionsScheduleScript;
};

type GetQuestionsScheduleScriptParams = {
	question: number;
	speciality: number;
	stateCode: string;
	cityName: string;
};

interface GetQuestionsScheduleScript {
	get: (params: GetQuestionsScheduleScriptParams) => Promise<GetQuestionsScheduleScriptModel>;
}

export {ScheduleScriptOptionTypeEnum};
export type {
	ScheduleScriptOption,
	QuestionsScheduleScript,
	GetQuestionsScheduleScriptModel,
	GetQuestionsScheduleScriptParams,
	GetQuestionsScheduleScript,
};
